import { CircularProgress, Stack, Typography } from '@mui/material';
import React from 'react';

type CommandPaletteEmptyStateProps = {
  title?: string;
  message?: string | React.JSX.Element;
  content?: string | React.JSX.Element;
  loading?: boolean;
};

function CommandPaletteEmptyState({
  title,
  message,
  content,
  loading,
}: CommandPaletteEmptyStateProps) {
  return (
    <Stack py="80px">
      <Stack direction="row" gap={1} justifyContent="center" alignItems="center">
        {loading && <CircularProgress size={24} />}
        <Typography variant="h6">{title}</Typography>
      </Stack>
      {content && <Stack>{content}</Stack>}
      {message && (
        <Typography variant="body2" align="center">
          {message}
        </Typography>
      )}
    </Stack>
  );
}

export default CommandPaletteEmptyState;
